import { render, staticRenderFns } from "./OrgList.vue?vue&type=template&id=a0010366&scoped=true&"
import script from "./OrgList.vue?vue&type=script&lang=ts&"
export * from "./OrgList.vue?vue&type=script&lang=ts&"
import style0 from "./OrgList.vue?vue&type=style&index=0&id=a0010366&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0010366",
  null
  
)

export default component.exports